export enum FavoriteTypeEnum {
  Report = 'Report',
  Dashboard = 'Dashboard',
  Chart = 'Chart'
}
